var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96855 12.875C5.08916 12.875 2.03516 10.9774 0.634766 8.5C2.0293 6.03272 5.08183 4.125 7.96855 4.125C10.8477 4.125 13.9019 6.02234 15.3023 8.5C13.9078 10.9672 10.8553 12.875 7.96855 12.875ZM7.96855 10.375C6.93474 10.375 6.09355 9.53382 6.09355 8.5C6.09355 7.46607 6.93474 6.625 7.96855 6.625C9.00249 6.625 9.84356 7.46607 9.84356 8.5C9.84356 9.53382 9.00249 10.375 7.96855 10.375Z",
    stroke: "#DD4242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrEye);
export default __webpack_public_path__ + "static/media/cr_eye.d4ec38b3.svg";
export { ForwardRef as ReactComponent };